export default [
  {
    path: '/teacher-subject-codes',
    name: 'teacher-subject-code',
    meta: { requiresAuth: true },
    component: () => import('@/pages/teacher-subject-code/index.vue')
  },
  {
    path: '/teacher-subject-codes/create',
    name: 'teacher-subject-code-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/teacher-subject-code/create.vue')
  }
]
